import GraphPage from './Container';

export default GraphPage;